/* @refresh reload */
import { Map as MapLibre, Marker } from "maplibre-gl";

import { findParent } from "./find-parent";
import type { UtdoDate } from "./types";
import { UtdoControl } from "./utdo-control";

function isDialog(el: HTMLElement): boolean {
    return el instanceof HTMLDialogElement;
}

function isDateDiv(el: HTMLElement): boolean {
    return el instanceof HTMLDivElement && el.classList.contains("date");
}

(async function()
{
    const main = document.querySelector("main.dates") as HTMLElement | undefined;
    if (!main) {
        return;
    }
    // fermeture des dialogs en cliquant sur le backdrop
    main.addEventListener("click", (ev) => {
        if (!(ev.target instanceof HTMLDialogElement)) {
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        const rect = ev.target.getBoundingClientRect();
        if (rect.bottom <= ev.clientY
            && ev.clientY <= rect.top
            && rect.left <= ev.clientX
            && ev.clientX <= rect.right) {
            return;
        }
        ev.target.close();
    });
    const mapContainer = main.querySelector("#dates-map > div");
    if (!mapContainer) {
        return;
    }
    const list = main.querySelector("#dates-list");
    if (!list) {
        return;
    }
    const toggle = main.querySelector("#dates-toggle") as HTMLInputElement | undefined;
    if (!toggle) {
        return;
    }
    // ouverture des infos
    list.addEventListener("click", (ev) => {
        if (!(ev.target instanceof HTMLAnchorElement)) {
            return;
        }
        if (!ev.target.classList.contains("info")) {
            return;
        }
        const date = findParent(ev.target, isDateDiv);
        if (!date) {
            return;
        }
        const dialog = date.querySelector("dialog");
        if (!dialog) {
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        dialog.showModal();
    })
    // déclarations des variables nécessaires pour les prochains évènements
    let map: MapLibre;
    const zoom = 4.5;
    const dates = new Map<string, UtdoDate>();
    let center: [ number, number ] = [ 2.531357315036445, 46.48120316969931 ];
    const control = new UtdoControl(center, dates, zoom);
    // click sur un des liens marqueurs
    list.addEventListener("click", (ev) => {
        if (!(ev.target instanceof HTMLAnchorElement)) {
            return;
        }
        if (!ev.target.classList.contains("marker")) {
            return;
        }
        const div = findParent(ev.target, isDateDiv) as HTMLDivElement | undefined;
        if (!div) {
            return;
        }
        const id = div.dataset.id;
        if (!id) {
            return;
        }
        const current = dates.get(id);
        if (!current) {
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        for (let d of dates.values()) {
            if (d.id === id) {
                continue
            }
            d.marker?.setOpacity("0");
            d.place?.classList.add("hidden");
        }
        current.marker?.setOpacity("1");
        current.place?.classList.remove("hidden");
        map.setCenter(current.coords);
        control.setCenter(current.coords);
        map.setZoom(10);
        toggle.checked = true;
    });
    // click sur "Afficher sur la carte"
    list.addEventListener("click", (ev) => {
        if (!(ev.target instanceof HTMLElement)) {
            return;
        }
        if (!ev.target.classList.contains("show-on-map")) {
            return;
            
        }
        const dialog = findParent(ev.target, isDialog) as HTMLDialogElement | undefined;
        if (!dialog) {
            return;
        }
        const div = findParent(dialog, isDateDiv);
        if (!div) {
            return;
        }
        const markerLink = div.querySelector("a.marker") as HTMLAnchorElement | undefined;
        if (!markerLink) {
            return;
        }
        markerLink.click();
        dialog.close();
    });
    // on récupère les dates depuis la page
    const elements = document.querySelectorAll("div.date[data-id]") as any as HTMLDivElement[];
    for (let el of elements) {
        const id = el.dataset.id?.trim();
        const lat = Number.parseFloat(el.dataset.lat ?? "");
        const lng = Number.parseFloat(el.dataset.lng ?? "");
        if (!id || Number.isNaN(lat) || Number.isNaN(lng)) {
            continue;
        }
        const date: UtdoDate = { id, coords: [ lng, lat ] };
        const place = el.querySelector("a.marker") as HTMLAnchorElement | undefined;
        if (place) {
            date.place = place;
        }
        dates.set(id, date);
    }
    // on récupère le style de la carte depuis les variables css (pour un futur dark mode ?)
    let style = window.getComputedStyle(document.body).getPropertyValue("--map-url");
    if (style.length == 0) {
        style = "https://openmaptiles.geo.data.gouv.fr/styles/osm-bright/style.json";
    }
    // affichage de la carte
    map = new MapLibre({
        container: (mapContainer as any),
        style,
        center: [0,0],
        zoom,
        zoomSnap: 0.5,
        rollEnabled: false,
        dragRotate: false,
        pitchWithRotate: false,
        attributionControl: false,
    });
    // à peu près le centre de la France
    // ajout des marqueurs
    if (dates.size > 0) {
        let lngSum = 0;
        let latSum = 0; 
        for (let date of dates.values()) {
            lngSum += date.coords[0];
            latSum += date.coords[1];
            date.marker = new Marker({
                    color: "var(--color-marker)",
                    draggable: false,
                })
                .setLngLat(date.coords)
                .addTo(map);
            date.marker.on("click", () => {
                if (!date.place) {
                    return;
                }
                const d = findParent(date.place, isDateDiv);
                if (!d) {
                    return;
                }
                const dialog = d.querySelector("dialog");
                if (!dialog) {
                    return;
                }
                dialog.showModal();
            });
        }
        center = [ lngSum / dates.size, latSum / dates.size ];
    }
    map.setCenter(center);
    map.addControl(control, "bottom-right");
})();
